import React, { useState } from "react";
import classNames from "classnames";
import { Module, ModuleCaption } from "Components/Module";
import { PaymentSettings } from "Components/PaymentSettings/PaymentSettings";
import { userSelector } from "Utils/selectors";
import { useSelector } from "react-redux";
import { PayableType } from "Services/API/API";

export interface PaymentInformationProps {
}

export const PaymentInformation: React.FC<PaymentInformationProps> = () => {
   const user = useSelector(userSelector);
   const [isLoading, setIsLoading] = useState<boolean>(true);

   return (<>
      { isLoading && <Module size="lg" loading={isLoading}>{/*  */}</Module> }
      <Module size="lg" className={classNames({ "d-none": isLoading })}>
         <ModuleCaption className="h5 mb-px24">
            Payment Method
         </ModuleCaption>
         { user.id && <PaymentSettings id={user.id} payableType={PayableType.Member} setLoading={ isLoading => setIsLoading(isLoading) }/> }
      </Module>
   </>);
}